<!--<ng-select [items]="list" placeholder="Choose your item" [searchable]="false"></ng-select>-->
<!--<div class="ui-grid-row" *ngFor="let myField of fields">

<ng-select placeholder="Choose your item" [compareWith]="compareFn" [(ngModel)]="model[myField.name]">
  <ng-option class="sem-text-box" *ngFor="let item of list" [value]="item">{{item.Title}}</ng-option>
</ng-select>

</div>-->
<!--<ng-select placeholder="Choose your item" [compareWith]="compareFn" (change)="ddChanged($event)">
<ng-option class="sem-text-box" *ngFor="let item of list" [value]="item">{{item[subBindingPropertyName]}}</ng-option>
</ng-select>
<br />-->

@if (type == 2) {
  <mat-form-field class="example-full-width" [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'sem-select-not-in-list': typedValueNotInList, 'disabled-field-dd': (checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true) && alwaysEditable != true }" (click)="(checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true) ? addToInlineSearchProps({value:value?.Title}) : null">
    @if (value && !checkForDisabled(getAttribute('name')) && dfms?.isFormReadOnly != true && !loadingResults) {
      <div (click)="clearValue($event)" class="dd-delete"></div>
    }
    @if (loadingResults && !checkForDisabled(getAttribute('name')) && dfms?.isFormReadOnly != true) {
      <div class="dd-loader autocomplete-loader"></div>
    }
    <span class="autocomplete-span">
      <input type="text" class="autocomplete-input" [matTooltip]="getValue()" placeholder="{{placeholder}}" (focus)="onFocus()" (blur)="onAutocompleteBlur()" value="{{getValue()}}" aria-label="Number" matInput (input)="onSearchChange($event.target.value)" [formControl]="myControl" [matAutocomplete]="auto" [readonly]="(checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true) && alwaysEditable != true"  [matAutocompleteDisabled]="(checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true) && alwaysEditable != true" [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }">
    </span>
    <!-- No [panelWidth]: Material then sizes the panel to the trigger, which is what these filters
         want. With [panelWidth]="'auto'" the overlay pane is left unconstrained, and because
         Material styles the panel itself width:100%, it stretches to the entire overlay container
         (the full viewport) rather than shrinking to its content. -->
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)" [class]="quickCreateAvailable && quickCreateUsesFooter ? 'wg-inline-create-panel' : ''" (opened)="onPanelOpenedChange(true)" (closed)="onPanelOpenedChange(false)" (selectionChange)="selectionChange($event)" (optionSelected)="optionSelected($event.option.value)">
      @for (option of filteredOptions | async; track option) {
        <mat-option [value]="option" [ngStyle]="{'min-width': minWidth}">
          {{resolvePropertyBinding(option,titleField)}}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  @if (typedValueNotInList) {
    <p class="sem-select-not-in-list-msg">{{ tr('WebGalis_ValueNotInList', 'Vrednost ni na seznamu') }}</p>
  }
}

<!--{{titleField}}
{{value | json}}-->


@if (type == 1) {
  <mat-form-field class="classic-dropdown"  [hideRequiredMarker]="true" (click)="(checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true) ? addToInlineSearchProps({value:value?.Title}) : null"
    [floatLabel]="'Choose your item'" [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field-dd': checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true }" >
    @if (value && !checkForDisabled(getAttribute('name')) && dfms?.isFormReadOnly != true && !loadingResults) {
      <div (click)="clearValue($event)" class="dd-delete"></div>
    }
    @if (loadingResults) {
      <div class="dd-loader"></div>
    }
    <mat-select #matSelect (focus)="focusDropdown()" (click)="dropdownSelectClick()" [(value)]="value" [compareWith]="compareFn" [disabled]="checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true" [panelClass]="quickCreateAvailable && quickCreateUsesFooter ? 'wg-inline-create-panel' : ''" (openedChange)="onPanelOpenedChange($event)" (selectionChange)="selectionChange($event)" (ngModelChange)="ngModelChangeEvent(ev)" (change)="ordinalChange(ev)">
      @for (item of list; track item) {
        <mat-option [value]="item" (onSelectionChange)="ddInitialSet($event)" [ngStyle]="{'min-width': minWidth}">
          {{resolvePropertyBinding(item,titleField)}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
}

@if (type == 4) {
  <div class="sem-tree-select"
    [ngClass]="{ 'is-invalid': form?.submitted && getName() != null, 'disabled-field-dd': (checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true) }">
    <div class="tree-select-field" (click)="toggleTreePanel()">
      @if (value && !checkForDisabled(getAttribute('name')) && dfms?.isFormReadOnly != true && !loadingResults) {
        <div (click)="clearValue($event)" class="dd-delete"></div>
      }
      @if (loadingResults) {
        <div class="dd-loader"></div>
      }
      <span class="tree-select-value" [matTooltip]="getValue()">{{ getValue() || placeholder }}</span>
      <span class="tree-select-caret" [class.sem-caret-open]="treePanelOpen"></span>
    </div>

    @if (treePanelOpen) {
      <div class="tree-select-backdrop" (click)="closeTreePanel()"></div>
      <div class="tree-select-panel">
        <div class="tree-select-search">
          <input type="text" [(ngModel)]="treeFilter" (input)="applyTreeFilter()" [placeholder]="placeholder || ''" />
        </div>
        <div class="tree-select-scroll">
          <mat-tree [dataSource]="treeDataSource" [treeControl]="treeControl" class="sem-tree">
            <mat-tree-node *matTreeNodeDef="let node" class="tree-leaf-node">
              <span class="tree-toggle-spacer"></span>
              <span class="tree-node-label" [class.selected]="value && value.Id == node.id" (click)="selectTreeNode(node)">{{ node.name }}</span>
            </mat-tree-node>
            <mat-nested-tree-node *matTreeNodeDef="let node; when: treeHasChild">
              <div class="tree-parent-node">
                <button type="button" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name" class="tree-toggle" (click)="$event.stopPropagation()">
                  <span class="tree-node-caret" [class.sem-caret-open]="treeControl.isExpanded(node)"></span>
                </button>
                <span class="tree-node-label" [class.selected]="value && value.Id == node.id" (click)="selectTreeNode(node)">{{ node.name }}</span>
              </div>
              <div class="tree-children" [class.tree-invisible]="!treeControl.isExpanded(node)">
                <ng-container matTreeNodeOutlet></ng-container>
              </div>
            </mat-nested-tree-node>
          </mat-tree>
        </div>
      </div>
    }
  </div>
}

@if (quickCreateAvailable && quickCreateMode === 'panel' && (type == 1 || type == 2)) {
  <button type="button" class="wg-quick-create-trigger" (click)="openQuickCreatePanel($event)" title="Dodaj nov zapis" aria-label="Dodaj nov zapis">
    <span class="material-symbols-outlined">key</span>
  </button>
}

@if (quickCreateAvailable && quickCreateMode === 'inline' && (type == 1 || type == 2)) {
  <ng-template #inlineCreateFooterTpl>
    <div class="wg-inline-create-footer"
         (click)="$event.stopPropagation()"
         (mousedown)="$event.stopPropagation()"
         (keydown)="$event.stopPropagation()">
      <input type="text"
             class="wg-inline-create-input"
             [(ngModel)]="inlineCreateText"
             [disabled]="inlineCreating"
             (keyup.enter)="createInline()"
             [placeholder]="inlineCreatePlaceholder">
      <button type="button"
              class="wg-inline-create-save"
              [disabled]="inlineCreating || !(inlineCreateText && inlineCreateText.trim().length > 0)"
              (click)="createInline()"
              title="Shrani"
              aria-label="Shrani">
        @if (inlineCreating) {
          <span class="material-symbols-outlined wg-inline-create-spinner">progress_activity</span>
        } @else {
          <span class="material-symbols-outlined">check</span>
        }
      </button>
    </div>
  </ng-template>
}

@if (quickCreateAvailable && quickCreateMode === 'full-form' && (type == 1 || type == 2)) {
  <ng-template #fullFormFooterTpl>
    <div class="wg-inline-create-footer wg-full-form-footer"
         (click)="$event.stopPropagation()"
         (mousedown)="$event.stopPropagation()"
         (keydown)="$event.stopPropagation()">
      <button type="button"
              class="wg-full-form-add"
              (click)="openQuickCreateFullForm($event)"
              [title]="tr('WebGalis_QuickCreate_AddNew', 'Dodaj nov vnos')">
        <span class="material-symbols-outlined">add</span>
        <span>{{ tr('WebGalis_QuickCreate_AddNew', 'Dodaj nov vnos') }}</span>
      </button>
    </div>
  </ng-template>
}

@if (useAsMultiField) {
  <div class="multi-fields" style="padding-bottom:15px;">
    <sem-multi-fields  [isReadOnly]="getReadOnly()"  [multiFields]="multiFields" [minWidth]="minWidth" [model]="model" [multiFieldRootPropertyBinding]="multiFieldRootPropertyBinding" ></sem-multi-fields>
  </div>
}

@if (type == 3) {
  <mat-radio-group
    aria-labelledby="example-radio-group-label"
    class="example-radio-group"
    [(ngModel)]="value" (change)="radioChange($event)" [disabled]="(checkForDisabled(getAttribute('name')) || dfms?.isFormReadOnly == true)">
    @for (item of list; track item) {
      <mat-radio-button class="example-radio-button" [value]="item" (change)="radioButtonChange($event)">{{resolvePropertyBinding(item,titleField)}}</mat-radio-button>
    }
  </mat-radio-group>
}


<p class="binding-prop-name">{{getAttribute('name')}}</p>